import { api } from "api/common";
import {
  GET_FEATURE_SETTINGS,
  SET_FEATURE_SETTINGS
} from "api/constants";
import { setToastMessage } from "components/app/actions";
import { createActionsHook } from "react-redux-actions-hook";
import {FeatureSettingsActionType} from "./constants"

export const getFeatureSettings = () => {
  return (dispatch, stateFn) => {
    api(
      `${GET_FEATURE_SETTINGS}`,
      { method: "GET" },
      dispatch
    )
      .then((res) => {
        dispatch(setFeatures(res?.data));   
       
      })
      .catch((error) => {
        //Handle Error
        dispatch(
          setToastMessage({
            message: error.message || "Unable to get Feature Settings",
            type: "error",
          })
        );
      });
  };
};

export const setFeatureSettings = (data) => {
  return (dispatch, stateFn) => {
    api(
      `${SET_FEATURE_SETTINGS}`,
      { method: "PUT", body: JSON.stringify(data) },
      dispatch
    )
      .then((res) => {
        dispatch(
          setToastMessage({
            message: res.message || "Updated Feature Settings Successfully",
            type: "success",
          })
        );
        dispatch(getFeatureSettings(res?.data))
       
      })
      .catch((error) => {
        //Handle Error
        dispatch(
          setToastMessage({
            message: error.message || "Updated Feature Settings Failed",
            type: "success",
          })
        );
      });
  };
};

export const setFeatures = (data) => {
  
  return { type: FeatureSettingsActionType.SET_FEATURE_SETTINGS, data };
};

export default createActionsHook({
  
  getFeatureSettings,
  setFeatureSettings,
  setFeatures
});
